<template>
  <b-card
    class="ban-preview"
  >
    <player-ban-link
      :playerId="playerId"
      :banId="object.id"
    />

    <table>
      <tr>
        <th>Banner</th>
        <td>
          <user-link
            :user="getUser(object.userId)"
          />
        </td>
      </tr>
      <tr>
        <th>Begin</th>
        <td>{{object.ctime | getMomentMinStr}}</td>
      </tr>
      <tr>
        <th>Duration type</th>
        <td>{{getBanDurationTypeName}}</td>
      </tr>
      <tr v-if="isTemp">
        <th>Planned duration</th>
        <td>{{getPlannedDurationStr}}</td>
      </tr>
      <tr v-if="isTemp">
        <th>Planned end</th>
        <td>{{getFtimeStr}}</td>
      </tr>
      <tr class="util-tr">
        <th>Planned duration</th>
        <td></td>
      </tr>
    </table>

  </b-card>
</template>

<script>
import { getBanDurationTypeName as utilGetBanDurationTypeName } from '../model/player_ban.js';
import { getPlayerBanPlannedDurationStr                       } from '../model/player_ban.js';
import { getPlayerBanFtimeStr                                 } from '../model/player_ban.js';
import { getUserFromMap } from '../model/user';

import PlayerBanLink from './PlayerBanLink.vue';
import UserLink from './UserLink.vue';

export default {
  name: 'PlayerBanPreview',

  components: {
    PlayerBanLink,
    UserLink,
  },

  props: {
    playerId: {
      type: Number,
      required: true,
    },

    object: {
      type: Object,
      required: true,
    },

    userMap: {
      type: Map,
      required: true,
    },
  },

  computed: {
    getBanDurationTypeName() {
      return utilGetBanDurationTypeName(this.object);
    },

    getPlannedDurationStr() {
      return getPlayerBanPlannedDurationStr(this.object);
    },

    getFtimeStr() {
      return getPlayerBanFtimeStr(this.object.ftime);
    },

    isTemp() {
      return this.object.ftime > 0;
    },
  },

  methods: {
    getUser(userId) {
      return getUserFromMap(this.userMap, userId);
    },
  },
};
</script>

<style scoped>
.ban-preview .card-body {
  padding: 8px;
}

.ban-preview th {
  padding-right: .5rem;
}

.util-tr {
  line-height: 0;
  overflow: hidden;
  visibility: hidden;
}
</style>
